<template>
  <el-dialog
      :visible.sync="visible"
      title="合同明细编辑"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
  >
    <el-form
        :model="dataForm"
        :rules="dataRule"
        ref="dataForm"
        label-width="120px"
    >
      <el-row :gutter="16">
        <el-col :span="12">
          <el-form-item label="品番号：" prop="code">
            <el-input
                v-model="dataForm.code"
                placeholder="请输入品番号"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="品名：" prop="name">
            <el-input
                v-model="dataForm.name"
                placeholder="请输入产品名称"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="尺寸：" prop="size">
            <el-input
                v-model="dataForm.size"
                placeholder="请输入尺寸"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="颜色：" prop="color">
            <el-input
                v-model="dataForm.color"
                placeholder="请输入颜色"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="SKU编号：" prop="skuCode">
            <el-input
                v-model="dataForm.skuCode"
                placeholder="请输入SKU编号"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="中文品名：" prop="nameZh">
            <el-input
                v-model="dataForm.nameZh"
                placeholder="请输入中文品名"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="合同数量：" prop="count">
            <el-input
                v-model="dataForm.count"
                placeholder="请输入合同数量"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="合同单价：" prop="amount">
            <el-input
                v-model="dataForm.amount"
                placeholder="请输入合同单价"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="分组名称：" prop="skuCode">
            <OrderDetailGroup v-model="dataForm.groupName" :allow-create="true"
                              :order-id="dataForm.agreementId"></OrderDetailGroup>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="每箱入数：" prop="boxCount">
            <el-input
                v-model="dataForm.boxCount"
                placeholder="请输入每箱入数"
            ></el-input>
          </el-form-item>
        </el-col>

      </el-row>
    </el-form>
    <template slot="footer">
      <div style="display: flex;justify-content:space-between;align-items: center">
        <div style="flex:1;display: flex;align-items: center;justify-content: flex-start;">
          <div style="font-size: 16px;margin: 0 10px;">总金额<span
              style="color:red;font-weight:bold;margin: 0 5px;">{{ totalAmount }}</span></div>
          <div v-if="makeDetailList&&makeDetailList.length>0" style="font-size: 16px;">
            当前品番关联加工单<span style="color:red;font-weight:bold;margin: 0 5px;">{{ makeDetailList.length }}</span>个
            <el-checkbox v-model="isEditMakeDetail" style="margin-left: 10px;">同步修改相关加工单</el-checkbox>
          </div>
        </div>
        <div>
          <el-button @click="cancel">{{ $t('cancel') }}</el-button>
          <el-button type="primary" @click="dataFormSubmitHandle()">{{
              $t('confirm')
            }}
          </el-button>
        </div>
      </div>
    </template>
  </el-dialog>
</template>

<script>
import { moneyValidator, isPositiveNumber } from '@/utils/validate'
import debounce from 'lodash/debounce'
import OrderDetailGroup from '@/components/OrderDetailGroup.vue'

export default {
  components: { OrderDetailGroup },
  data () {
    return {
      id: '',
      visible: false,
      dataForm: {},
      makeDetailList: [],
      isEditMakeDetail: false,
    }
  },
  computed: {
    totalAmount () {
      if (!this.dataForm.count || !this.dataForm.amount) {
        return 0
      }
      return new this.$BigNumber(this.dataForm.amount)
          .multipliedBy(this.dataForm.count)
          .toFixed(2)
    },
    dataRule () {
      return {
        name: [{ required: true, message: '请填写名称', trigger: 'change' }],
        code: [{ required: true, message: '请填写品番号', trigger: 'change' }],
        amount: [
          { required: true, message: '请填写单价', trigger: 'change' },
          { validator: moneyValidator, trigger: 'change' },
        ],
        count: [
          { required: true, message: '请填写数量', trigger: 'change' },
          {
            validator: function (rule, value, callback) {
              if (value && !isPositiveNumber(value)) {
                callback(new Error('请输入正确的数量'))
              } else {
                callback()
              }
            },
            trigger: 'change',
          },
        ]
      }
    },
  },
  methods: {
    reset () {
      if (this.id) {
        this.getInfo()
      } else {
        this.dataForm = {
          agreementId: '',
          id: '',
          name: '',
          code: '',
          color: '',
          size: '',
          amount: '',
          count: '',
          boxCount: '',
          skuCode: '',
          nameZh: '',
          backCount: 1,
          unit: '',
          bomList: [],
        }
        if (this.$refs['dataForm']) {
          this.$refs['dataForm'].resetFields()
        }
      }
    },
    getInfo () {
      if (!this.id) {
        return
      }
      this.$api2.get(`/erp/order/detail/info/${this.id}`).then(data => {
        this.queryRefMakeDetail()
        this.dataForm = {
          ...data,
          name: data.product.name,
          code: data.product.code,
          skuCode: data.product.skuCode,
          nameZh: data.product.nameZh,
          color: data.product.color,
          size: data.product.size,
        }
        this.$nextTick(() => {
          this.$refs.dataForm.clearValidate()
        })
      })
    },
    //获取关联的制造明细
    async queryRefMakeDetail () {
      const data = await this.$api2.get(`/erp/make/detail/list/${this.id}`)
      this.makeDetailList = data
    },
    init () {
      this.isEditMakeDetail = true
      this.makeDetailList = []
      this.reset()
      this.visible = true
    },
    async postEdit () {
      let postForm = {
        id: this.dataForm.id,
        product: {
          name: this.dataForm.name,
          code: this.dataForm.code,
          skuCode: this.dataForm.skuCode,
          nameZh: this.dataForm.nameZh,
          color: this.dataForm.color,
          size: this.dataForm.size,
        },
        count: this.dataForm.count,
        amount: this.dataForm.amount,
        boxCount: this.dataForm.boxCount,
        groupName: this.dataForm.groupName,
        isEditMakeDetail: this.isEditMakeDetail,
      }
      const res = await this.$api2.post('/erp/order/detail/edit', postForm)
      this.$message.success('保存成功')
      this.visible = false
      this.$emit('changed')
    },
    // 表单提交
    dataFormSubmitHandle: debounce(
        function () {
          this.$refs['dataForm'].validate((valid) => {
            if (!valid) {
              return false
            }
            if (this.id) {
              this.postEdit()
            }
          })
        },
        1000,
        { leading: true, trailing: false }
    ),
    cancel () {
      this.visible = false
    },
  },
}
</script>
